export class OffboardingSettings {
  ID: number;
  FeedbackTypeId: string;
  Contacts: string;
  CreatedBy: string
  CreatedDate: Date;
  ModifiedDate: Date;
  ModifiedBy: string;
  duplicateContact: boolean;
  EmpName: string;
  EmpCode: number;

}
